module.exports = __webpack_public_path__ + "img/outside_2.97c366af.png";